import * as R from 'ramda'

function _default_to(default_value, value) {
    return R.compose(

        // Wenn String leer ist, dann angegeben Default-Wert zurueckgeben
        R.when(R.propEq('length', 0), R.always(default_value)),

        // String trimme
        R.trim,

        // ggf. zu String casten
        R.when(R.complement(R.is(String)), R.toString),

        // ggf. leeren String als Default-Wert setzen
        R.defaultTo(''),

    )(value)
}

export const default_to = R.curry(_default_to)

export function truncate(value, length = 20, suffix = '…') {
    return R.compose(

        // ggf. String kuerzen und `suffix` anhaengen
        R.when(
            R.propSatisfies(R.gt(R.__, length), 'length'),
            R.pipe(R.take(length), R.trim, R.append(suffix), R.join(''))
        ),

        // String trimmen
        R.trim,

        // Pruefen ob gueltiger String
        R.unless(R.is(String), R.always(''))

    )(value)
}
